// @ts-nocheck
import { convertFromHTML, EditorState, ContentState, SelectionState } from 'draft-js';

import { stateToHTML } from 'draft-js-export-html';
import { stateFromHTML } from 'draft-js-import-html';

import { EditorValueFormat } from './enums';

const MAX_HTML_LENGTH = 3000;

// Regex to detect actual HTML tags (not just text containing tag names)
const hasRestrictedTags = (html: string): boolean => {
  // Match opening tags: <img, <video, etc. (with optional attributes and closing >)
  const restrictedTagPattern = /<(img|video|audio|iframe|object|embed|script|style)[\s>]/i;
  return restrictedTagPattern.test(html);
};

export const buildInitialValue = (
  format: EditorValueFormat,
  value: ContentState | string | undefined,
): EditorState => {
  if (!value) {
    return EditorState.createEmpty();
  }

  if (
    typeof value === 'string' &&
    format === EditorValueFormat.Html &&
    (hasRestrictedTags(value) || value.length > MAX_HTML_LENGTH)
  ) {
    const blocksFromHTML = convertFromHTML(value as string);
    const state = ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,
      blocksFromHTML.entityMap,
    );
    return EditorState.createWithContent(state);
  }

  switch (format) {
    case EditorValueFormat.PlainText:
      return EditorState.createWithContent(ContentState.createFromText(value as string));
    case EditorValueFormat.Html:
      return EditorState.createWithContent(stateFromHTML(value as string));
    case EditorValueFormat.DraftJsObject:
      return EditorState.createWithContent(value as ContentState);
  }
};

export const buildOutputValue = (
  format: EditorValueFormat,
  state: EditorState,
): ContentState | string => {
  switch (format) {
    case EditorValueFormat.Html:
      return stateToHTML(state.getCurrentContent());
    case EditorValueFormat.DraftJsObject:
      return state.getCurrentContent();
    case EditorValueFormat.PlainText:
    default:
      return state.getCurrentContent().getPlainText();
  }
};

export const moveCursorToEnd = (state: EditorState) => {
  const content = state.getCurrentContent();
  const blockMap = content.getBlockMap();

  const key = blockMap.last()?.getKey();
  const length = blockMap.last()?.getLength();

  const selection = new SelectionState({
    anchorKey: key,
    anchorOffset: length,
    focusKey: key,
    focusOffset: length,
  });
  return EditorState.forceSelection(state, selection);
};
